import type { DealCategoryTreeNode } from 'apis/exclusive-deals';

// Catalog categories are assignable at depths 2–4; 0 and 1 are grouping-only.
export const SELECTABLE_DEPTHS = [2, 3, 4];

export function isSelectableDepth(depth: number): boolean {
  return SELECTABLE_DEPTHS.includes(depth);
}

/**
 * Depth-first search for `id`, returning the root→self lineage (inclusive).
 * Returns [] when the id is not present in the forest.
 */
export function findCategoryPath(tree: DealCategoryTreeNode[], id: number): DealCategoryTreeNode[] {
  for (const node of tree) {
    if (node.id === id) return [node];
    const childPath = findCategoryPath(node.children, id);
    if (childPath.length) return [node, ...childPath];
  }
  return [];
}

export interface CategorySearchHit {
  node: DealCategoryTreeNode;
  /** Root→self lineage (inclusive) — feed it straight into the cascade's selectedPath. */
  path: DealCategoryTreeNode[];
}

/**
 * Case-insensitive title search over the whole forest, depth-first so hits
 * come back in tree order. Capped at `limit` — typing more narrows the rest.
 */
export function searchCategories(tree: DealCategoryTreeNode[], query: string, limit = 50): CategorySearchHit[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const hits: CategorySearchHit[] = [];
  const walk = (nodes: DealCategoryTreeNode[], lineage: DealCategoryTreeNode[]) => {
    for (const node of nodes) {
      if (hits.length >= limit) return;
      const path = [...lineage, node];
      if ((node.title || '').toLowerCase().includes(q)) hits.push({ node, path });
      walk(node.children, path);
    }
  };
  walk(tree, []);
  return hits;
}
